// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import layersThree01Icon from "@/assets/icons/layers-three-01.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type LayersThree01IconProps = Omit<IconProps, "name">;

export function LayersThree01Icon(props: LayersThree01IconProps): React.ReactNode {
  return <Icon name={layersThree01Icon} {...props} />;
}
